import { app } from "@microsoft/teams-js";
import { TeamsSurveyResponse } from "@teams/types";
import { SurveyDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { surveyApi } from "../../_shared/services/SurveyApi";
import { isError } from "../services/ChannelApi";

type LoadSurveyOptions = {
  loadResponses?: boolean;
  hideLoader?: boolean;
  ignoreError?: boolean;
};

export const useSurvey = <T extends TeamsSurveyResponse>(defaults?: LoadSurveyOptions) => {
  const [isSurveyLoading, setIsSurveyLoading] = useState<boolean>(true);
  const [survey, setSurvey] = useState<SurveyDTO>();
  const [surveyError, setSurveyError] = useState<Error>();
  const [serverTime, setServerTime] = useState<Date>();
  const [surveyResponses, setSurveyResponses] = useState<Array<T>>([]);

  const loadSurvey = useCallback(
    async (contextOrToken: app.Context | string, surveyId: string, options?: LoadSurveyOptions) => {
      let useOptions = defaults;
      if (options) {
        useOptions = {
          ...useOptions,
          ...options,
        };
      }

      if (!useOptions?.hideLoader) {
        setIsSurveyLoading(true);
      }

      const response = await surveyApi.survey(contextOrToken, surveyId, useOptions?.loadResponses);
      if (isError(response)) {
        setSurveyError(response);
      } else {
        setSurvey(response.survey);
        setServerTime(response.serverTime);

        if (useOptions?.loadResponses && response.survey.responses) {
          setSurveyResponses(response.survey.responses as T[]);
        }
      }

      setIsSurveyLoading(false);
      return response;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    loadSurvey,
    isSurveyLoading,
    survey,
    surveyError,
    serverTime,
    surveyResponses,
  };
};
